import React from 'react';
import './ErrorBoundary.css';

/* Without this, any throw during render unmounts the whole tree and the user
 * gets a white page with nothing to report — which is how the oversized search
 * payload presented. Keep it dumb: show what happened and offer a way out. */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        console.error('Unhandled render error:', error, info?.componentStack);
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (!this.state.error) return this.props.children;

        return (
            <div className="fs error-boundary">
                <h1>Something went wrong</h1>
                <p>
                    The page hit an error and could not carry on. Reloading usually
                    clears it. If it keeps happening, tell us what you were doing and
                    we will look into it.
                </p>
                <button type="button" className="btn btn-primary" onClick={this.handleReload}>
                    Reload the page
                </button>
            </div>
        );
    }
}

export default ErrorBoundary;
